import React, {Component} from 'react'
import {Form, isSubmitting} from 'procedures/changeDependents/remove/Form'
import {connect} from 'react-redux'
import api from 'api'
import {actionCreators, fetchSelector} from 'actions'
import withRouterLegacy from 'withRouterLegacy'
import {get, pick, isEmpty} from 'lodash'
import CommentModal from 'procedures/CommentModal'
import Button from 'jbc-front/components/Button'
import checkEmployeeConfirm from 'components/checkEmployeeConfirm'
import compose from 'lodash/fp/compose'
import {isAdminSelector} from 'utils'
import {asyncError} from 'store/actions/asyncError'

const makeRemoveDependentsData = (removeDependentsData) => {
  if (isEmpty(removeDependentsData.dependents)) return {}

  const dateOn = removeDependentsData.date_on
  const removeDependents = removeDependentsData.dependents.map((dependent) => {
    if (!dependent.dependent_social_insurance && !dependent.removed_on) {
      dependent.removed_on = dateOn
    }
    if (!dependent.dependent_tax_law && !dependent.removed_tax_law_on) {
      dependent.removed_tax_law_on = dateOn
    }

    return dependent
  })

  return {date_on: dateOn, dependents: removeDependents}
}

class Confirm extends Component {
  componentDidMount() {
    const {
      match: {
        params: {id},
      },
      loadProcedureStatus,
      token,
      loadTmpData,
      loadComments,
    } = this.props
    loadProcedureStatus(id, token)
    loadTmpData(id, token)
    loadComments(id, token)
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  makeInitialValues() {
    const {
      tmpData: {application_procedure_remove_dependents: removeDependentsData},
      procedureStatus: {employee},
    } = this.props

    if (removeDependentsData) {
      return makeRemoveDependentsData(removeDependentsData)
    }
    return employee && employee.employee_dependents
      ? {
          dependents: employee.employee_dependents.map((dependent) =>
            pick(dependent, [
              'first_name',
              'last_name',
              'id',
              'remove_reason_detail',
              'remove_reason_type',
              'relation_type',
              'died_on',
            ])
          ),
        }
      : {}
  }

  render() {
    const {
      procedureStatus: {employee},
      match: {
        params: {id},
      },
      submitting,
      healthInsuranceType,
      isAdmin,
      comments,
    } = this.props
    return (
      <div>
        <CommentModal procedureStatusId={id} comments={comments || []} procedureType="changeDependents">
          {({showModal}) => (
            <Form
              onSubmit={this.handleSubmit}
              employee={employee}
              initialValues={this.makeInitialValues()}
              submitText="承認して次へ"
              otherButtons={
                <Button disabled={submitting} onClick={showModal} className="u-mr20">
                  修正を依頼する
                </Button>
              }
              healthInsuranceType={healthInsuranceType}
              comments={comments || {}}
              isAdmin={isAdmin}
            />
          )}
        </CommentModal>
      </div>
    )
  }

  handleSubmit = (values) => {
    const {
      updateAndAccept,
      procedureStatus,
      match: {
        params: {id},
      },
      token,
      history,
    } = this.props
    return updateAndAccept(id, procedureStatus.employee_id, values, token, history)
  }
}

export default compose(
  withRouterLegacy,
  checkEmployeeConfirm({procetureType: 'remove_dependents'}),
  connect(
    (state) => ({
      procedureStatus: state.procedureStatuses.current.data,
      tmpData: state.procedureStatuses.tmpData.data,
      comments: fetchSelector(state, 'procedure_comments').data,
      submitting: isSubmitting(state),
      healthInsuranceType: get(state.procedureStatuses.current.data.employee, 'office.health_insurance_type'),
      isAdmin: isAdminSelector(state),
      token: state.auth.token,
    }),
    (dispatch) => ({
      loadProcedureStatus: (id, token) => {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(
            api.createWithAuth(token).procedureStatuses.get(id, ['employee', 'employee_dependents', 'office'])
          )
        )
      },
      loadTmpData: (procedureStatusId, token) => {
        dispatch(
          actionCreators.procedureStatuses.tmpData.fetchData(
            api.createWithAuth(token).procedureStatuses.tmpData.mapToJson(procedureStatusId, {
              type: 'application',
              name: 'procedure_remove_dependents',
            })
          )
        )
      },
      loadComments: (procedureStatusId, token) => {
        dispatch(
          actionCreators.fetchData(
            'procedure_comments',
            api.createWithAuth(token).procedureStatuses.procedureComments.list(procedureStatusId)
          )
        )
      },
      destroy: () => {
        dispatch(actionCreators.procedureStatuses.current.destroy())
        dispatch(actionCreators.procedureStatuses.tmpData.destroy())
      },
      updateAndAccept: async (procedureStatusId, employeeId, {dependents, date_on: dateOn}, token, history) => {
        const authedApi = api.createWithAuth(token)
        try {
          await authedApi.procedureStatuses.update(procedureStatusId, {date_on: dateOn})
          for (let dependent of dependents) {
            await authedApi.employees.dependents.update(employeeId, dependent)
            await authedApi.procedureStatuses.removeDependentsData.create(
              procedureStatusId,
              dependent.id,
              dependent.is_report_target
            )
          }
          await authedApi.procedureStatuses.accept(procedureStatusId)
          history.push(`/remove_dependents/flow/${procedureStatusId}`)
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  )
)(Confirm)
